// Side-effect module: marks when JS bundle has been loaded and executed.
// Must be imported as the very first import in index.js.
import { perfMark } from './perfTracker';
perfMark('reactMount');
